export default function PHP_ftp_fget() {
  return (
    <div>
      <h1>PHP_ftp_fget</h1>
    </div>
  );
}
